import React, { CSSProperties, InputHTMLAttributes } from 'react';
import { IconBaseProps } from 'react-icons';
import { ClipLoader } from 'react-spinners';

import { Container, InputContainer, InputSuffix, ErrorMessage, InputPreffix } from './styles';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  suffix?: string;
  preffix?: string;
  icon?: React.ComponentType<IconBaseProps>;
  style?: CSSProperties;
  error?: string;
  isLoading?: boolean;
};

const Input: React.ForwardRefRenderFunction<any, InputProps> = (
  { id, label, suffix, preffix, icon: Icon, style, error, isLoading, ...rest },
  ref,
) => {
  return (
    <Container style={style}>
      {label && <label htmlFor={id}>{label}</label>}
      <InputContainer hasIcon={!!Icon} hasError={!!error}>
        {Icon && <Icon />}
        {isLoading && (
          <ClipLoader className="loading" color="#04aa6d" size={20} />
        )}
        {preffix && (
          <InputPreffix hasError={!!error}>
            <span>{preffix}</span>
          </InputPreffix>
        )}
        <input id={id} ref={ref} {...rest} />
        {suffix && (
          <InputSuffix hasError={!!error}>
            <span>{suffix}</span>
          </InputSuffix>
        )}
      </InputContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};

export default React.forwardRef(Input);
